import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {FieldConfig} from '../field.interface';

@Component({
    selector: 'app-checkbox',
    template: `
<div class="demo-full-width margin-top" [formGroup]="group" >
<mat-checkbox [formControlName]="field.key" (change)="toggleCheckbox($event)">{{field.label}}</mat-checkbox>
</div>
`,
    // host: {'class': 'col-md-6'},
    styles: [],
    standalone: false
})
export class CheckboxComponent implements OnInit {
  field: FieldConfig;
  group: UntypedFormGroup;
  // @HostBinding('class') rowClass = 'col-md-6';
  @Output() selectedValue = new EventEmitter();
  constructor() { }
  ngOnInit() {
    //  this.rowClass = this.field.rowClass === 'large' ? 'col-md-12' : 'col-md-6';
  }

  toggleCheckbox(event) {
    this.selectedValue.emit({ value: event.checked, field: this.field });
  }
}
